import i18n from '@src/i18n/config';

export const getTemporaryFranchise = (days: number) =>
  i18n.t('PETS_FORM_DATA:hints.activatedNoEarlier', {
    day: days,
  });
